import { useEffect, useState } from "react";
import Loader from "./components/Loader";
import Navbar from "./components/NavBar/navbar";
import Hero from "./sections/Hero/hero";
import Vision from "./sections/Vision/vision";
import About from "./sections/About/about";
import Skills from "./sections/Skills/skills";
import Projects from "./sections/Projects/projects";
import Experience from "./sections/Experience/experience";
import Achievements from "./sections/Achievement/Achievements";
import Testimonials from "./sections/Testimonials/Testimonials";
import Contact from "./sections/Contact/contact";
import Footer from "./sections/Footer/footer";
import { Analytics } from "@vercel/analytics/react";
import './App.css';
import './responsive.css';
import NoTestimonials from "./sections/Testimonials/NoTestimonials";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 5500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="appDiv">
      {loading ? (
        <div className={`loader ${!loading ? 'fade-out' : ''}`}>
          <Loader />
        </div>
      ) : (
        <>
          <Navbar />
          <div className="main-container fade-in">
            <Hero />
            <Vision />
            <About />
            <Skills />
            <Projects />
            <Experience />
            <Achievements />
            <NoTestimonials />
            <Testimonials />
            <Contact />
          </div>
          <Footer />
          <Analytics />
        </>
      )}
    </div>
  );
};

export default App;
